/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'HEADER.title',
    defaultMessage: 'Third Bridge Transcription App',
  },
  homeMenuItem: {
    id: 'HEADER.homeMenuItem',
    defaultMessage: 'Home',
  },
  dashboardMenuItem: {
    id: 'HEADER.dashboardMenuItem',
    defaultMessage: 'Dashboard',
  },
  adminMenuItem: {
    id: 'HEADER.adminMenuItem',
    defaultMessage: 'Admin',
  },
  logoutMenuItem: {
    id: 'HEADER.logoutMenuItem',
    defaultMessage: 'Logout',
  },
  loginMenuItem: {
    id: 'HEADER.loginMenuItem',
    defaultMessage: 'Login',
  },
  settingsMenuItem: {
    id: 'HEADER.settingsMenuItem',
    defaultMessage: 'Settings',
  },
  createConference: {
    id: 'HEADER.createConference',
    defaultMessage: 'Schedule Conference Call',
  },
  createTranscript: {
    id: 'HEADER.createTranscript',
    defaultMessage: 'Submit Transcript Order',
  },
  createTranscription: {
    id: 'HEADER.createTranscription',
    defaultMessage: 'Create transcript',
  },
  createOrganization: {
    id: 'HEADER.createOrganization',
    defaultMessage: 'Create client',
  },
});



// WEBPACK FOOTER //
// ./components/organisms/Header/messages.js